import {
  createApiFactory,
  createPlugin,
  createRouteRef,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { CopilotBudgetApiClient, copilotBudgetApiRef } from './api';

export const rootRouteRef = createRouteRef({
  id: 'copilot-budget:root',
});

export const copilotBudgetPlugin = createPlugin({
  id: 'copilot-budget',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: copilotBudgetApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new CopilotBudgetApiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const CopilotBudgetPage = copilotBudgetPlugin.provide(
  createRoutableExtension({
    name: 'CopilotBudgetPage',
    component: () => import('./components/CopilotBudgetPage').then(m => m.CopilotBudgetPage),
    mountPoint: rootRouteRef,
  }),
);
